export type SocialPrivacySetting = 'initials' | 'anonymous' | 'full_name';

export interface ClientPrivacyFields {
  display_name?: string | null;
  social_privacy_setting?: SocialPrivacySetting | null;
  allow_social_comparison?: boolean | null;
}

export function getPrivacyPreviewName(
  displayName: string,
  privacySetting: SocialPrivacySetting
): string {
  switch (privacySetting) {
    case 'anonymous':
      return 'Anonymous Client';
    case 'initials':
      return (
        displayName
          .split(' ')
          .filter(Boolean)
          .map((word) => word.charAt(0))
          .join('')
          .toUpperCase()
          .slice(0, 2) + '.'
      );
    case 'full_name':
      return displayName;
    default:
      return displayName;
  }
}

export function resolveLeaderboardDisplayName(
  clientName: string,
  privacy?: ClientPrivacyFields | null
): string {
  const displayName = privacy?.display_name?.trim() || clientName;
  const setting = (privacy?.social_privacy_setting as SocialPrivacySetting) || 'initials';
  return getPrivacyPreviewName(displayName, setting);
}

export function getLeaderboardAvatarInitials(
  clientName: string,
  privacy?: ClientPrivacyFields | null
): string {
  const setting = (privacy?.social_privacy_setting as SocialPrivacySetting) || 'initials';
  if (setting === 'anonymous') return '?';

  const displayName = privacy?.display_name?.trim() || clientName;
  return displayName
    .split(' ')
    .filter(Boolean)
    .map((word) => word.charAt(0))
    .join('')
    .toUpperCase()
    .slice(0, 2);
}

export function shouldHideLeaderboardPhoto(
  privacy?: ClientPrivacyFields | null
): boolean {
  return privacy?.social_privacy_setting === 'anonymous';
}
